import { STEPS } from "../data/constants";

export function StepBar({ current }) {
  return (
    <ol
      aria-label="Booking progress"
      style={{
        display: "flex",
        alignItems: "center",
        listStyle: "none",
        gap: 0,
      }}
    >
      {STEPS.map((label, i) => {
        const n = i + 1;
        const done = n < current;
        const active = n === current;
        return (
          <li
            key={label}
            aria-current={active ? "step" : undefined}
            style={{ display: "flex", alignItems: "center" }}
          >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
              <div
                style={{
                  width: 24,
                  height: 24,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 11,
                  fontWeight: 700,
                  transition: "all .35s var(--ease-spring)",
                  background: done
                    ? "var(--gold)"
                    : active
                    ? "linear-gradient(135deg, var(--mauve), var(--mauve-deep))"
                    : "rgba(255, 255, 255, 0.1)",
                  color: done || active ? "#fff" : "rgba(255, 255, 255, 0.35)",
                  boxShadow: active ? "0 0 16px rgba(196, 135, 154, 0.65)" : "none",
                }}
              >
                {done ? "✓" : n}
              </div>
              <div
                style={{
                  fontSize: 9,
                  fontWeight: 600,
                  letterSpacing: 0.5,
                  whiteSpace: "nowrap",
                  color: active
                    ? "rgba(255, 255, 255, 0.95)"
                    : done
                    ? "rgba(255, 255, 255, 0.6)"
                    : "rgba(255, 255, 255, 0.3)",
                }}
              >
                {label}
              </div>
            </div>
            {i < STEPS.length - 1 && (
              <div
                aria-hidden="true"
                style={{
                  width: 18,
                  height: 1.5,
                  background: n < current ? "var(--gold)" : "rgba(255, 255, 255, 0.18)",
                  margin: "0 4px 16px",
                  transition: "background .35s var(--ease-out)",
                }}
              />
            )}
          </li>
        );
      })}
    </ol>
  );
}
